import React from 'react'
import "./ChristmasBanner.css";

function  ChristmasBanner() {
  return (
    <div className="Christmas_Banner"> <p>Liebe Kunden: Wir haben Weihnachtsurlaub vom 22.12.2022 bis 8.1.2023</p></div>
  )
}

export default ChristmasBanner